import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.partner.analyses.length
    ? _c(
        "div",
        {
          staticClass: "partner-card-border overflow-hidden",
          attrs: { "data-qa": "partner_analyses_list" },
        },
        [
          _c(
            "div",
            {
              class: _setup.isMobile ? "pa-4" : "pa-6",
              attrs: {
                "data-partner-id": _vm.partner.id,
                "data-partner-name": _vm.partner.name,
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "d-flex",
                  class: { "flex-column": _setup.isMobile },
                },
                [
                  _c(VImg, {
                    staticClass: "mb-6",
                    class: {
                      "mx-auto": _setup.isMobile,
                      " flex-grow-1 mr-6": !_setup.isMobile,
                    },
                    attrs: {
                      "max-width": "240px",
                      "min-width": "240px",
                      "max-height": "80px",
                      "min-height": "80px",
                      src: _vm.partner.logo,
                      alt: `Логотип ${_vm.partner.name}`,
                      contain: "",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column flex-grow-2 w-100" },
                    [
                      !_setup.isMobile
                        ? _c(
                            _setup.PrgButton,
                            {
                              staticClass: "mb-6",
                              attrs: {
                                "button-attrs": {},
                                url: `/${_setup.town.translit}/analyses/${_vm.partner.slug}`,
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "primary--text text-h5" },
                                [
                                  _vm._v(
                                    "\n            Лаборатория «" +
                                      _vm._s(_vm.partner.name) +
                                      "»\n          "
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(_setup.AnalysesList, {
                        attrs: {
                          "show-cart-button": "",
                          partner: _setup.localPartner,
                          "disable-cart-button": _setup.isAnalysisLoading,
                        },
                        on: {
                          "click:add-to-cart": (analysis) =>
                            _setup.handleAddAnalysisToCart(
                              _setup.localPartner,
                              analysis
                            ),
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        _setup.PrgButton,
                        {
                          staticClass: "mx-auto",
                          attrs: {
                            "data-qa": "partner-analyses-button-all",
                            "button-attrs": {
                              class:
                                "primary--text mx-auto bg-primary py-2 px-4 rounded-sm",
                            },
                            url: `/${_setup.town.translit}/analyses/${_vm.partner.slug}`,
                          },
                        },
                        [
                          _c("span", { staticClass: "text-button" }, [
                            _vm._v("\n            Показать ещё\n          "),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _vm.useBanner
            ? _c(_setup.DiscountBanner, {
                attrs: { discount: _vm.partner.discount },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }